import { render, staticRenderFns } from "./TabBox.vue?vue&type=template&id=f547112c&scoped=true&"
import script from "./TabBox.vue?vue&type=script&lang=js&"
export * from "./TabBox.vue?vue&type=script&lang=js&"
import style0 from "./TabBox.vue?vue&type=style&index=0&id=f547112c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f547112c",
  null
  
)

export default component.exports